import React, { useState, useEffect } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Dropdown, Space, message, Avatar, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { callLogout } from "../../config/api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { isMobile } from "react-device-detect";
import { fetchAccount, setLogoutAction } from "../../redux/slice/accountSlide";
import classNames from "classnames/bind";
import styles from "./AdminLayout.module.scss";
import MenuAdmin from "./components/menu";
import NotFound from "../../components/Share/not.found";

const css = classNames.bind(styles);

const { Content } = Layout;

const AdminLayout = ({ children }: { children: any }) => {
  const [collapsed, setCollapsed] = useState(false);
  const user = useAppSelector((state) => state.account.user);

  useEffect(() => {
    dispatch(fetchAccount());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    const res = await callLogout();
    if (res && res.data) {
      dispatch(setLogoutAction({}));
      message.success("Đăng xuất thành công");
      navigate("/");
    }
  };

  const itemsDropdown = [
    {
      label: <Link to={"/"}>Trang chủ</Link>,
      key: "home",
    },
    {
      label: (
        <label style={{ cursor: "pointer" }} onClick={() => handleLogout()}>
          Đăng xuất
        </label>
      ),
      key: "logout",
    },
  ];

  // Logic to determine whether to render the content based on user role
  const renderContent = () => {
    const userRole = user?.role?.name;

    if (userRole !== "NORMAL_USER") {
      return (
        <Layout className={css("layout-admin")}>
          <MenuAdmin />
          <Layout>
            {!isMobile && (
              <div
                className="admin-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: 20,
                }}>
                <Button
                  type="text"
                  icon={
                    collapsed
                      ? React.createElement(MenuUnfoldOutlined)
                      : React.createElement(MenuFoldOutlined)
                  }
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: "16px",
                    width: 64,
                    height: 64,
                  }}
                />

                <Dropdown menu={{ items: itemsDropdown }} trigger={["click"]}>
                  <Space style={{ cursor: "pointer" }}>
                    Welcome {user?.name}
                    <Avatar src={user.avatar}>{user.name}</Avatar>
                  </Space>
                </Dropdown>
              </div>
            )}
            <Content className={css("content")} style={{ padding: "15px" }}>
              {children}
            </Content>
          </Layout>
        </Layout>
      );
    } else {
      return <NotFound />;
    }
  };

  return <>{renderContent()}</>;
};

export default AdminLayout;
